import * as Animate from "react-reveal";

const traditionalSteps = [
  "Post a job",
  "500 applications",
  "CV screening",
  "Recruiter handoff",
  "Assessment",
  "Interviews",
  "Weeks",
];

const utivaSteps = [
  "Tell us who you need",
  "Matched assessed talent",
  "Interview",
  "Hire",
];

const HireCompressionSection = () => {
  return (
    <section className="bg-white py-16 md:py-20 lg:py-24 px-4">
      <div className="container mx-auto">
        <Animate.Fade bottom>
          <p className="flex items-center gap-3 text-primary font-poppins text-sm font-extrabold tracking-widest uppercase mb-6">
            <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
            The work is already done
          </p>
        </Animate.Fade>

        <Animate.Fade bottom>
          <h2 className="text-3xl md:text-4xl lg:text-5xl leading-tight font-poppins font-black mb-6 max-w-3xl tracking-[-0.03em]">
            <span className="text-default">Skip the application pile.</span>{" "}
            <span className="text-primary">Start with proven readiness.</span>
          </h2>
        </Animate.Fade>

        <Animate.Fade bottom>
          <p className="text-gray text-base md:text-lg font-poppins leading-relaxed max-w-2xl mb-12 lg:mb-14">
            Utiva has already developed the professionals, built the talent
            pipeline and created the assessment layer. Tell us who you need.
          </p>
        </Animate.Fade>

        <div className="grid grid-cols-1 lg:grid-cols-hire-compression items-center gap-6 lg:gap-4">
          <Animate.Fade bottom>
            <div className="border border-hire-line bg-[#fafbfe] rounded-3xl p-6 md:p-7 h-full">
              <div className="flex flex-wrap justify-between items-center gap-3 pb-5 mb-5 border-b border-hire-line">
                <span className="text-[#875600] font-poppins text-sm font-extrabold tracking-widest uppercase">
                  Traditional hiring
                </span>
                <b className="text-gray font-poppins text-sm font-bold">
                  Weeks of fragmented work
                </b>
              </div>
              <div className="grid gap-2">
                {traditionalSteps.map((step, index) => (
                  <div
                    key={step}
                    className="bg-white rounded-xl flex items-center gap-4 px-4 py-4"
                  >
                    <span className="text-gray-2 font-poppins text-sm font-extrabold w-6 flex-shrink-0">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                    <p className="text-default font-poppins font-bold text-base m-0">
                      {step}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </Animate.Fade>

          <Animate.Fade bottom>
            <div className="flex lg:flex-col items-center justify-center gap-3 py-4 lg:py-0">
              <span className="text-gray font-poppins text-xs font-extrabold tracking-widest uppercase">
                Compressed by
              </span>
              <strong className="text-primary font-poppins text-xl font-extrabold">
                UTIVA
              </strong>
              <span className="w-14 h-14 rounded-full bg-secondary text-primary flex items-center justify-center text-2xl rotate-90 lg:rotate-0">
                →
              </span>
            </div>
          </Animate.Fade>

          <Animate.Fade bottom>
            <div className="bg-primary rounded-3xl p-6 md:p-7 shadow-course-feature-lg h-full">
              <div className="flex flex-wrap justify-between items-center gap-3 pb-5 mb-5 border-b border-white/15">
                <span className="text-secondary font-poppins text-sm font-extrabold tracking-widest uppercase">
                  With Utiva
                </span>
                <b className="text-indigo-100 font-poppins text-sm font-bold">
                  A focused path to hire
                </b>
              </div>
              <div className="grid gap-2">
                {utivaSteps.map((step, index) => (
                  <div
                    key={step}
                    className="bg-white rounded-xl flex items-center justify-between gap-4 px-4 py-4"
                  >
                    <div className="flex items-center gap-4">
                      <span className="text-gray-2 font-poppins text-sm font-extrabold w-6 flex-shrink-0">
                        {String(index + 1).padStart(2, "0")}
                      </span>
                      <p className="text-default font-poppins font-bold text-base m-0">
                        {step}
                      </p>
                    </div>
                    <span className="text-utiva-green font-bold">✓</span>
                  </div>
                ))}
              </div>
            </div>
          </Animate.Fade>
        </div>
      </div>
    </section>
  );
};

export default HireCompressionSection;
